import React, { memo } from 'react'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { brandColors } from 'transfix-ui/theme/colors'
import { ICarrierRequirementFragment } from '../../graphql/CarrierRequirementFragment'

interface ICarrierRequirementsListProps {
  requirements: ICarrierRequirementFragment[]
}

const CarrierRequirementList = memo<ICarrierRequirementsListProps>(({ requirements }) => {
  return (
    <Box mt={1.5} pt={1.5} px={1.5} pb={0.5} bgcolor={brandColors.coolGray1}>
      {requirements.map(({ carrierAttr, shipperRequirement }) => {
        const [reqTitle = ''] = shipperRequirement.split(':') || []
        return (
          <Box key={reqTitle} mb={1}>
            <Typography variant='subtitle1'>{reqTitle}</Typography>
            <Typography variant='body2'>{carrierAttr}</Typography>
          </Box>
        )
      })}
    </Box>
  )
})

export default CarrierRequirementList
